import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations'
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DeviceSwapModalComponent } from '../device-swap-modal/device-swap-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-accordian-table',
  templateUrl: './accordian-table.component.html',
  styleUrls: ['./accordian-table.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AccordianTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tableData: any;
  @Input() columnHeader: any;
  @Output() accordionTableAction = new EventEmitter<any>();

  objectKeys = Object.keys;
  dataSource = new MatTableDataSource([]);
  subTableColumnHeader: any = {};
  expandedElement: null;
  private _attributeThreshold: any[] = [];
  private _afterClosedSubscription: Subscription;

  constructor(private _router: Router, private _dialog: MatDialog, private _sharedService: ServicecallService) { }

  ngOnInit(): void {
    this._attributeThreshold = this._sharedService.getConfiguration('attributeThreshold') ? this._sharedService.getConfiguration('attributeThreshold').threshold : [];
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
  }
  ngOnChanges() {
    this._initializeTable();
  }
  clickActions(actionType: string, rowData: any) {
    if (actionType === 'note') {
      this._router.navigate(['people/profile/' + rowData?.entityId], { queryParams: { tenantType: 'dover' } });
    } else if (actionType === 'map') {
      let dialogRef1 = this._dialog.open(DeviceSwapModalComponent, {
        width: '50%',
        data: { msg: 'map', deviceDetails: rowData },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef1.afterClosed().subscribe(result => {
        if (result?.status) {
          this.accordionTableAction.emit({ action: 'refreshApi' });
        }
      });
    }
  }

  getClassOf(tableElm: any, columnName: string) {
    let color;
    if (columnName === 'Skin Temperature °C') {
      color = (+tableElm['Skin Temperature °C'] <= this._findFromList(columnName, 'upper') && +tableElm['Skin Temperature °C'] >= this._findFromList(columnName, 'lower')) ? 'safe' : 'unsafe';
    } else if (columnName === 'Respiratory Rate') {
      color = (+tableElm['Respiratory Rate'] <= this._findFromList(columnName, 'upper') && +tableElm['Respiratory Rate'] >= this._findFromList(columnName, 'lower')) ? 'safe' : 'unsafe';
    } else if (columnName === 'Activity') {
      color = 'safe';
    } else if (columnName === 'Battery') {
      color = (+tableElm['Battery'] <= this._findFromList(columnName, 'upper') && +tableElm['Battery'] >= this._findFromList(columnName, 'lower')) ? 'safe' : 'unsafe';
    } else {
      color = '';
    }
    return color;
  }
  private _initializeTable() {
    this.subTableColumnHeader = { ...this.columnHeader };
    // delete this.subTableColumnHeader['action'];
    this.dataSource.data = this.tableData.map((elem: any) => ({ ...elem, hover: false }));
  }
  private _findFromList(itemToCheck: string, thresholdType: string) {
    const filteredItem = this._attributeThreshold.find((item: any) => item.name === itemToCheck)?.alertThreshold?.find((elem: any) => elem.name === thresholdType)?.threshold;
    return filteredItem ? +filteredItem : null;
  }
  
}
